<section class="toast-stack" *ngIf="(toast.messages$ | async) as messages">
  <article *ngFor="let item of messages" class="toast-item" [ngClass]="'is-' + item.tone">
    <div class="toast-copy">
      <strong>{{ item.title }}</strong>
      <p *ngIf="item.message">{{ item.message }}</p>
    </div>
    <button type="button" class="toast-close" (click)="toast.remove(item.id)" aria-label="Close">
      ×
    </button>
  </article>
</section>
